import React, { useState, useRef } from "react";
import "./BookPageDropDown.css";
import DevelopTool from "./DevelopToolComponents/DevelopTool";
import { ThemeProvider } from "@mui/material";
import DevelopTheme from "./DevelopToolComponents/DevelopTheme";
import Tooltip from "@material-ui/core/Tooltip";
import BookPageDropDownV2 from "./BookPageDropDownV2";
import ConfirmationModal from "../micro_components/ConfirmationModal";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import TokenService from "../../services/auth/TokenService";
import AuthoringToolTwoPointZero from "../AuthoringToolTwoPointZero";
//"../../public/json_data_local/" + jsonfile
//look up how to do it with load times in MageeProjects / react sketch/react project/ Todo
const DevelopBook = (props) => {
  const { book } = props;
  const [currentPage, setCurrentPage] = useState();
  const [videoLink, setVideoLink] = useState();
  const [pageId, setPageId] = useState();
  const [preview, setPreview] = useState(false);
  const jsonData = useRef([]);
  const [jsonPage, setJsonPage] = useState();
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [currentChapter, setCurrentChapter] = useState();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  console.log({ book });
  // const [refreshListener, setRefreshListener] = useState(0);

  // CONFRIMATION
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(true);

  const [currentPages, setCurrentPages] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [currentChapterIndex, setCurrentChapterIndex] = useState(0);
  // const reloadPages = () => {};

  const handleConfirmationClose = () => {
    setConfirmationOpen(false);
  };

  const renameCurrentJson = (name) => {
    let currentPagesCopy = currentPages;

    currentPagesCopy[currentPageIndex].jsonLink = name;

    setCurrentPages(currentPagesCopy);

    let chaptersCopy = chapters;

    chaptersCopy[currentChapterIndex].pages[currentPageIndex].jsonLink = name;

    setChapters(chaptersCopy);
  };

  return (
    <>
      <div className="develop-book-drop-down-container">
        <BookPageDropDownV2
          bookId={book.id}
          setChapterVideoLink={setVideoLink}
          setPageId={setPageId} // For reader uploading json
          setPageSrc={setCurrentPage} // For image src
          // setJsonData={setJsonData} //array of JSONs for page
          setJsonPage={setJsonPage} //single page json
          setCurrentPageIndex={setCurrentPageIndex} //for reader to toggle
          jsonData={jsonData.current} //parent json data
          currentPageIndex={currentPageIndex} //current page
          // refreshListener={refreshListener}
          pageId={pageId} //page id
          currentPages={currentPages}
          setCurrentPages={setCurrentPages}
          chapters={chapters}
          setChapters={setChapters}
          currentChapter={currentChapter}
          setCurrentChapter={setCurrentChapter}
          currentChapterIndex={currentChapterIndex}
          setCurrentChapterIndex={setCurrentChapterIndex}
        />
        <Tooltip
          disableFocusListener
          title="Preview the book as it will appear to the user"
          placement="top"
          arrow
        >
          <div className="previewToggleContainer">
            <span className={preview ? "untoggled" : "toggled"}>
              <b>Edit</b>
            </span>
            <label className="switch">
              <input
                checked={preview}
                type="checkbox"
                onChange={() => {
                  setPreview(!preview);
                }}
              />
              <span className="previewSlider round"></span>
            </label>
            <span className={preview ? "toggled" : "untoggled"}>
              <b>Preview</b>
            </span>
          </div>
        </Tooltip>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div>
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              Preview In Reader
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem onClick={handleClose}>
                <a
                  href={`https://reader-v2.netlify.app?mode=testing&href=https://dpi-authoring-image.s3.us-west-1.amazonaws.com/${book.id}/bookData&book=${book.id}&isAuthoring=true`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    padding: "0.25rem 0.5rem",
                    borderRadius: "5px",
                    backgroundColor: "#d9f0df",
                    textDecoration: "none",
                  }}
                >
                  Reader v1
                </a>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <a
                  href={`https://reader-app-nextjs-lovat.vercel.app/?mode=testing&href=https://dpi-authoring-image.s3.us-west-1.amazonaws.com/${book.id}/bookData&book=${book.id}&isAuthoring=true`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    padding: "0.25rem 0.5rem",
                    borderRadius: "5px",
                    backgroundColor: "#d9f0df",
                    textDecoration: "none",
                  }}
                >
                  Reader v2
                </a>
              </MenuItem>
            </Menu>
          </div>
          {/* <a
            href={`https://reader-v2.netlify.app?mode=testing&href=https://dpi-authoring-image.s3.us-west-1.amazonaws.com/${book.id}/bookData&book=${book.id}&isAuthoring=true`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: "0.25rem 0.5rem",
              borderRadius: "5px",
              backgroundColor: "#d9f0df",
              textDecoration: "none",
            }}
          >
            Preview in reader
          </a> */}
        </div>
      </div>

      {/* {videoLink && currentPage && pageId && currentPageIndex >= 0 && ( */}
      {currentPage && pageId && currentPageIndex >= 0 && (
        <div className="develop-book-content">
          <ThemeProvider theme={DevelopTheme}>
            <DevelopTool
              isHeresAmericaDomain={book?.domain_id?.toString() === "14"}
              bookId={book.id}
              passedPage={currentPage}
              pageId={pageId}
              videoLink={videoLink}
              preview={preview}
              setPreview={setPreview}
              jsonData={jsonPage}
              chapterAndPageInfo={{
                currentPageIndex,
                pageId,
                currentChapterId: currentChapter.id,
                currentChapterIndex,
              }}
              // reloadPages={reloadPages}
              setLoadingUpload={setConfirmationLoading}
              setUploadingModalOpen={setConfirmationOpen}
              setCurrentPageJson={renameCurrentJson}
              currentChapter={currentChapter}
            />
          </ThemeProvider>
          {confirmationOpen && (
            <ConfirmationModal
              title="Changes Saved!"
              isOpen={confirmationOpen}
              onClose={handleConfirmationClose}
              isLoading={confirmationLoading}
            />
          )}
        </div>
      )}
    </>
  );
};

export default DevelopBook;

// CurrentPage:  https://d24hdgytax3x03.cloudfront.net/26/pages/pageContent32
// DevelopBook.jsx:36 VideoLink:  https://player.vimeo.com/external/631043006.hd.mp4?s=babea74b8b321cf3b7c4aa0f15a480b7d73bf686&profile_id=175
// DevelopBook.jsx:37 Current page index:  1
// DevelopBook.jsx:38 page id:  32
